import commitmentModelDefinition from '../commitment'
import goalMetaModelDefinition from '../goal/goalMeta';
import moment from '@/moment-gp'

const empty_commitment_additional_type_specific_fields = commitmentModelDefinition.schema.additional_type_specific_fields;
const empty_goal = goalMetaModelDefinition.schema.create;

export default {
  create({ user_id, type }, data, BACKEND) {

    const DEFAULT_PICTURE = 'https://firebasestorage.googleapis.com/v0/b/goalpilot-dev.appspot.com/o/goal_pics_predefined%2Fways-to-save-money-while-traveling.jpg?alt=media&token=5cb04a25-61e5-4e81-82c1-b82433bae4c1';

    let challenge = {
      // Basic document management {
      createdAt:    moment.currentTimeServer(BACKEND),
      createdBy:    user_id,
      deleted:      false,
      sortidx:      1,
      // }

      // Essential challenge fields {
      type:                         type || 'COMMITMENT',     // COPIED!
      createGoalOnInstatiation:     data.createGoalOnInstatiation || false, /* should we create a new goal when instantiating? */
      joinGoalOnInstatiation:       data.joinGoalOnInstatiation || false,   /* should we join an existing goal when instantiating? */
      picture:                      data.picture || DEFAULT_PICTURE,
      // }

      // Statistics {
      statistics: {
        populariy:    3.5,  // Popularity score
        nrDoing:      1100, // 1100 people are doing this
        nrWishlist:   800,  // 800 people have this goal on their wishlist
        nrWatching:   3,    // "accountabilityBuddies" - number of accountability buddies .. "10 People are watching you do this". they can leave likes, comments etc.
      },
      // }

      // ### if TYPE === * {
      name:                         data.name || '',          // COPIED!
      startDate:                    data.startDate || null,   // COPIED if defined!
      endDate:                      data.endDate || null,     // COPIED if defined!
      allowToEdit:                  data.allowToEdit === undefined ? true : data.allowToEdit, // COPIED!
      // ### }
    };

    if ( challenge.createGoalOnInstatiation ) {
      // If challenge is mapped to a NEW goal
      let goal_template = empty_goal( // TODO
        data.goal ? data.goal.title : 'Goal Title',
        user_id,
        null,
        data.goal ? data.goal.picture : '',
        true,
        BACKEND );

      goal_template.graphicalRepresentation = data.goal ? (data.goal.graphicalRepresentation || {}) : {};

      Object.assign(challenge, {
        goalTemplate: goal_template
      })
    }
    if ( challenge.joinGoalOnInstatiation ) {
      // If challenge is mapped to an EXISTING goal
      Object.assign(challenge, {
        goalTemplate: {
          id: data.goal.existing_goal_id,
          name: data.goal.title
        }
      })
    }

    challenge = Object.assign(
      challenge,
      empty_commitment_additional_type_specific_fields(type, data) // TODO
    );

    // DELME:

    // switch (type) {
    //   case 'COMMITMENT_TEMPLATE':
    //   Object.assign(commitment, {
    //     commitmentTemplateId:       data.commitmentTemplateId || null,
    //     dataFields:                 data.dataFields || {},
    //     sessionLength:              Number.parseInt(data.sessionLength) || 30,
    //     maxSessionsPerDay:          Number.parseInt(data.maxSessionsPerDay) || -1,
    //     maxSessionsPerWeek:         Number.parseInt(data.maxSessionsPerWeek) || -1,
    //   })
    //   break;
    //
    //   case 'COMMITMENT':
    //   Object.assign(commitment, {
    //     commitmentOptionsSelected:  data.commitmentOptionsSelected || [],
    //     minSessionsPerDay:          Number.parseInt(data.minSessionsPerDay) || 0,
    //     maxSessionsPerDay:          Number.parseInt(data.maxSessionsPerDay) || 99,
    //     sessionLength:              Number.parseInt(data.sessionLength) || 30,
    //     amount:                     data.amount || 10,
    //     finishedPercent:            0,
    //   })
    //   break;
    //
    //   case 'SEQUENCE_TYPE1':
    //   Object.assign(commitment, {
    //     sessionType1TemplateList:   data.sessionType1TemplateList || [ /* sesion template items */ ],
    //   })
    //   break;
    //
    //   case 'SEQUENCE_TYPE2':
    //   Object.assign(commitment, {
    //     templateRepeat:             data.templateRepeat || 1,
    //     currentIndex:               data.currentIndex || 0,
    //     sessionType2TemplateList:   data.sessionType2TemplateList || [ /* sesion template items */ ],
    //   })
    //   break;
    //
    //   case 'FIXED_TSC':
    //   Object.assign(commitment, {
    //     timeslotCollectionTemplate:  empty_timeslot_collection('COMMITMENT')
    //   })
    //   break;
    //
    //   case 'NONE':
    //   /* This can be used if challenge is 'just' a goal without any commitments */
    //   break;
    // }

    return challenge;
  },

  fields: {
    createdAt: { validate_bolt_type: 'ServerTimestamp' },
    createdBy: {},
    deleted: {},
    sortidx: {},
    type: {},
    createGoalOnInstatiation: {},
    joinGoalOnInstatiation: {},
    picture: {},
    statistics: {},
    name: {},
    startDate: {},
    endDate: {},
    allowToEdit: {},
  }
};
